import { settings } from './app/app.settings'
import * as Sentry from '@sentry/browser'

export default function initSentry() {
  Sentry.init({
    environment: settings.sentry.environment,
    dsn: settings.sentry.dsn,
    // Alternatively, use `process.env.npm_package_version` for a dynamic release version
    // if your build tool supports it.
    integrations: [
      new Sentry.BrowserTracing(),
      new Sentry.Replay()
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: settings.sentry.traceSampleRate,

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: settings.sentry.replaysSessionSampleRate,
    replaysOnErrorSampleRate: settings.sentry.replaysOnErrorSampleRate
  })
}
